import React, { useEffect, useState } from 'react';

import Popup, { type ContentProps } from '@atlaskit/popup';

import { Mention, type MentionProps } from '../mention';

export type MentionPopupProps = Omit<MentionProps, 'content'> & {
	isOpen?: boolean;
	content: (props: MentionProps & ContentProps) => React.ReactNode;
};

export const MentionPopup = ({
	isOpen: open = false,
	content,
	...mentionProps
}: MentionPopupProps): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState(open);

	useEffect(() => setIsOpen(open), [open]);

	function handleKeyPress(event: React.KeyboardEvent<HTMLSpanElement>) {
		if (event.code === 'Space' || event.code === 'Enter' || event.code === 'NumpadEnter') {
			event.preventDefault();
			setIsOpen((isOpenState) => !isOpenState);
		}
	}

	return (
		<Popup
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			trigger={(triggerProps) => (
				<Mention
					role="button"
					tabIndex={0}
					onClick={() => setIsOpen((open) => !open)}
					onKeyUp={(event) => handleKeyPress(event)}
					{...mentionProps}
					{...triggerProps}
				/>
			)}
			content={(contentProps) => content({ ...mentionProps, ...contentProps })}
		/>
	);
};
